import React from "react";
import { Button as MuiButton, ButtonProps, styled } from "@mui/material";
import { ReactComponent as GoogleLogo } from "../svgs/google.svg";
import { ReactComponent as LinkedInLogo } from "../svgs/linkedin.svg";
import { ReactComponent as FacebookLogo } from "../svgs/facebook.svg";

export interface SocialLoginButtonInterface {
  label?: string;
  loaderRenderer?: React.ReactElement;
  onClick?: () => void;
  type: "google" | "facebook" | "linkedIn";
}

const Button = styled(MuiButton)<ButtonProps>(({ theme }: any) => ({
  border: `1px solid ${theme.palette.common["borderGrey"]}`,
  lineHeight: 1.5,
  color: theme.palette.common.black,
  background: theme.palette.common.white,
  borderRadius: "5px",
}));

const SocialLoginButton = ({
  label,
  onClick,
  loaderRenderer,
  type = "google",
  ...props
}: SocialLoginButtonInterface) => {
  return (
    <Button
      variant="text"
      color="secondary"
      fullWidth
      onClick={onClick}
      startIcon={
        type === "google" ? (
          <GoogleLogo />
        ) : type === "facebook" ? (
          <FacebookLogo />
        ) : type === "linkedIn" ? (
          <LinkedInLogo />
        ) : (
          <GoogleLogo />
        )
      }
      {...props}
    >
      {loaderRenderer}
      {label}
    </Button>
  );
};
export default SocialLoginButton;
